import React from "react";
import { FaXmark } from "react-icons/fa6";
import { MdDownload } from "react-icons/md";
import formatCustomDateWithTime from "../helpers/customDateFormatWithTime";

// Modal Component to display the full event details
const EventDetailsModal = ({
  eventDetails,
  onClose,
  triggerViewTokens,
  triggerDownloadReport,
}) => {
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-xl w-full relative shadow-lg">
        {/* Close Button */}
        <FaXmark
          onClick={() => onClose()}
          className="cursor-pointer text-xl absolute top-3 right-3 text-gray-600 hover:text-gray-800"
        />

        {/* Modal Content */}
        <div className="px-4 space-y-4">
          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-gray-700">
              Organisation Name:
            </span>
            <span className="text-gray-900">
              {eventDetails?.organisation_name}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-gray-700">
              Organisation Address:
            </span>
            <span className="text-gray-900">
              {eventDetails?.organisation_address}{" "}
              {eventDetails?.organisation_city},{" "}
              {eventDetails?.organisation_pincode}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-gray-700">Registered On:</span>
            <span className="text-gray-900">
              {formatCustomDateWithTime(eventDetails?.registered_on)}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-gray-700">Eventor 1:</span>
            <span className="text-gray-900">
              {eventDetails?.eventor_1 || "—"}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-gray-700">Eventor 2:</span>
            <span className="text-gray-900">
              {eventDetails?.eventor_2 || "—"}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-gray-700">
              Organisation Mobile:
            </span>
            <span className="text-gray-900">
              {eventDetails?.organisation_mobile}
            </span>
          </div>
        </div> 
        <div className="text-center mt-4 p-1">
          <div className="flex justify-center gap-3">
            <button
              onClick={() => triggerViewTokens(eventDetails.event_id)}
              className="bg-blue-500 text-white p-2 px-4 border hover:bg-white hover:border-blue-500 hover:text-blue-500"
            >
              View Token List
            </button>
            {eventDetails?.result_file ? (
              <button
                onClick={() => triggerDownloadReport?.(eventDetails.result_file)}
                className="flex items-center gap-2 rounded-md bg-amber-500 px-4 py-2 font-black text-white shadow-md shadow-amber-200 transition-all hover:bg-amber-600 hover:shadow-lg hover:shadow-amber-300"
              >
                <MdDownload />
                Download Report
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default EventDetailsModal;
